import {Component,  Input, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {RefDataService} from '../../../shared/services/ref-data.service';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {WorkrequestLndNwViewmodel} from '../workrequest-lnd-nw-viewmodel';
import {WorkrequestLndNwDetails} from '../workrequest-lnd-nw-details';
import { AddressService } from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-lnd-nw',
  templateUrl: './workrequest-lnd-nw.component.html',
  styleUrls: ['./workrequest-lnd-nw.component.css']
})
export class WorkrequestLndNwComponent implements OnInit {
  @Input()
  installationNumber: string;
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestLndNwViewmodel;
  developmentNameControl: FormControl;
  numberOfLotsControl: FormControl;
  stageControl: FormControl;
  ResidentialRequiredControl: FormControl;
  CommercialRequiredControl: FormControl;
  IndustrialRequiredControl: FormControl;

  developmentNameControlMaxLength = 100;
  developmentNameControlMinLength = 1;

  stageControlMaxLength = 10;
  stageControlMinLength = 1;

  maximumLots = 5000;
  numberRegEx = /^[0-9]*$/;
  pricingZone: string = SERVICE_PROVIDER.CWW;

  constructor(private loginService: LoginService, private addressService: AddressService
    , private refDataService: RefDataService, private feeService: FeeService) {
    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestLndNwViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestLndNwDetails();
    }

    this.developmentNameControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.developmentNameControlMaxLength),
      Validators.minLength(this.developmentNameControlMinLength)
    ])]);

    this.numberOfLotsControl = new FormControl('', [Validators.compose([Validators.min(0),
      Validators.max(this.maximumLots), Validators.pattern(this.numberRegEx)])]);

    this.stageControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.stageControlMaxLength),
      Validators.minLength(this.stageControlMinLength)
    ])]);

    this.ResidentialRequiredControl = new FormControl({value: false, disabled: false});
    this.CommercialRequiredControl = new FormControl({value: false, disabled: false});
    this.IndustrialRequiredControl = new FormControl({value: false, disabled: false});

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    this.loadFees();
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  }

  public calculateTotalAmount(): void {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.applicationFeeAmount;
  }

  loadFees(): void {
    this.feeService.retrieveFees('LandDevelopment', this.loginService.getToken(), ok => {
        if (ok) {
          this.workRequestViewModel.applicationFeeAmount = this.feeService.getapplicationFeeAmount(this.pricingZone);
          this.applicationFeeRequired = true;
          this.calculateTotalAmount();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  get developmentName(): string {
    return this.workRequestViewModel.workrequestDetails.developmentName;
  }

  set developmentName(v: string) {
    this.workRequestViewModel.workrequestDetails.developmentName = v;
  }

  get numberOfLots(): number {
    return this.workRequestViewModel.workrequestDetails.numberOfLots;
  }

  set numberOfLots(v: number) {
    this.workRequestViewModel.workrequestDetails.numberOfLots = v;
  }

  get stage(): string {
    return this.workRequestViewModel.workrequestDetails.stage;
  }

  set stage(v: string) {
    this.workRequestViewModel.workrequestDetails.stage = v;
  }

  isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  set applicationFeeRequired(v: boolean) {
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).applicationFeeRequired = v;
  }

  get applicationFeeAmount(): number {
    return this.workRequestViewModel.applicationFeeAmount;
  }

  set Residentialrequired(v: boolean) {
    if (!v) {
      (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Residentialrequired = v;
      return;
    }
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Residentialrequired = v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Commercialrequired = !v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Industrialrequired = !v;
  }

  get Residentialrequired(): boolean {
      return (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Residentialrequired;
  }

  set Commercialrequired(v: boolean) {
    if (!v) {
      (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Commercialrequired = v;
      return;
    }
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Commercialrequired = v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Residentialrequired = !v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Industrialrequired = !v;
  }

  get Commercialrequired(): boolean {
    return (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Commercialrequired;
  }

  set Industrialrequired(v: boolean) {
    if (!v) {
      (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Industrialrequired = v;
      return;
    }
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Industrialrequired = v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Commercialrequired = !v;
    (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Residentialrequired = !v;
  }

  get Industrialrequired(): boolean {
    return (<WorkrequestLndNwDetails>this.workRequestViewModel.workrequestDetails).Industrialrequired;
  }

  get invalidSelectionError(): string {
    return   this.workRequestViewModel.invalidSelectionError;
  }

  displayErrorMessage(): string {
    this.workRequestViewModel.invalidSelectionError = '';
    this.developmentNameControl.markAsTouched();
    this.numberOfLotsControl.markAsTouched();

    this.ResidentialRequiredControl.markAsTouched();
    this.CommercialRequiredControl.markAsTouched();
    this.IndustrialRequiredControl.markAsTouched();
    this.stageControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (this.developmentNameControl.invalid) {
      if (this.developmentNameControl.hasError('maxlength')) {
        errorText += 'Development name cannot exceed ' +
          this.developmentNameControlMaxLength + ' characters' + '<br>';
      }

      if (this.developmentNameControl.hasError('minlength')) {
        errorText += 'Development name should be greater than' +
          this.developmentNameControlMinLength + ' characters' + '<br>';
      }

      if (this.developmentNameControl.hasError('required')) {
        errorText += 'Please enter Development name' + '<br>';
      }
    }

    if (this.numberOfLotsControl.invalid) {
      if (this.numberOfLotsControl.hasError('required')) {
        errorText += 'Please enter Number of lots' + '<br>';
      }

      if (this.numberOfLotsControl.hasError('pattern')) {
        errorText += 'Please enter numbers only in Number of lots' + '<br>';
      }
    } else if (this.numberOfLots <= 0) {
      errorText += 'Please enter Number of lots' + '<br>';
    }

    if (this.stageControl.invalid) {
      if (this.stageControl.hasError('maxlength')) {
        errorText += 'Stage cannot exceed ' +
          this.stageControlMaxLength + ' characters' + '<br>';
      }

      if (this.stageControl.hasError('minlength')) {
        errorText += 'Stage should be greater than' +
          this.stageControlMinLength + ' characters' + '<br>';
      }

      if (this.stageControl.hasError('required')) {
        errorText += 'Please enter Stage' + '<br>';
      }
    }

    if (!this.Residentialrequired && !this.Commercialrequired && !this.Industrialrequired) {
      errorText += 'Please select type of development' + '<br>';
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.developmentNameControl.markAsUntouched();
    this.numberOfLotsControl.markAsUntouched();
    this.stageControl.markAsUntouched();
    this.ResidentialRequiredControl.markAsUntouched();
    this.CommercialRequiredControl.markAsUntouched();
    this.IndustrialRequiredControl.markAsUntouched();

    this.loadFees();
  }

  get getCssClass(): string {
    if (!this.isGuestUserLoggedIn()) {
      if (this.isReadOnly) {
        return 'form-control';
      }

      return 'no-border col-md-6';
    }

    return 'form-control';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-nw-form/workrequest-lnd-nw/workrequest-lnd-nw.component.ts